import { session } from "./vue/utlis/session";

/**
 * Если статус 419 то
 * 
 * Обновить сессию и повторить запрос
 * 
 * иначе вернуть обратно ошибку
 */
export const handleSessionExpired = async (err) => {
  if (err.response?.status === 419) {
    await session.updateSessid();
    return err.retry();
  }

  return Promise.reject(err);
}